import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import getDisplayName from "./lib/getDisplayName"
import TooltipContainer from "./TooltipContainer"

export default ComposedComponent =>
  class TooltipedComponent extends PureComponent {
    composed = null

    static displayName = getDisplayName(ComposedComponent, `Tooltip`)

    static propTypes = {
      tooltipContainerStyle: PropTypes.shape({}),
      tooltipContainerClassName: PropTypes.string,
      tooltipStyle: PropTypes.shape({}),
      tooltipClassName: PropTypes.string,
      tooltipLabel: PropTypes.node,
      tooltipDelay: TooltipContainer.propTypes.delay,
      tooltipPosition: TooltipContainer.propTypes.position,
      tooltipTransitionEnterTimeout: TooltipContainer.propTypes.enterTimeout,
      tooltipTransitionLeaveTimeout: TooltipContainer.propTypes.leaveTimeout,
      tooltipFixed: PropTypes.bool,
    }

    static defaultProps = {
      tooltipContainerStyle: {},
      tooltipContainerClassName: ``,
      tooltipStyle: {},
      tooltipClassName: ``,
      tooltipLabel: {},
      tooltipDelay: 0,
      tooltipPosition: `bottom`,
      tooltipTransitionEnterTimeout: 150,
      tooltipTransitionLeaveTimeout: 150,
      tooltipFixed: false,
    }

    getComposedComponent = () => this.composed

    setComposedComponent = component => {
      this.composed = component
    }

    render() {
      const {
        tooltipLabel,
        tooltipDelay,
        tooltipPosition,
        tooltipStyle,
        tooltipClassName,
        tooltipContainerStyle,
        tooltipContainerClassName,
        tooltipTransitionEnterTimeout,
        tooltipTransitionLeaveTimeout,
        tooltipFixed,
        ...props
      } = this.props

      if (tooltipLabel) {
        props.tooltip = (
          <TooltipContainer
            className={tooltipContainerClassName}
            delay={tooltipDelay}
            enterTimeout={tooltipTransitionEnterTimeout}
            key="tooltipContainer"
            label={tooltipLabel}
            leaveTimeout={tooltipTransitionLeaveTimeout}
            position={tooltipPosition}
            style={tooltipContainerStyle}
            tooltipClassName={tooltipClassName}
            tooltipFixed={tooltipFixed}
            tooltipStyle={tooltipStyle}
          />
        )
      }

      return <ComposedComponent {...props} ref={this.setComposedComponent} />
    }
  }
